import { get } from 'object-path-immutable';
import {
  addTheme as addTextTheme,
  overrides as textOverrides,
  extractStyles as extractTextStyles,
} from './text';
import {
  calculateOverridePaths,
  styleToThemeStyle,
  augmentedWrap,
} from './utils';

const PATHS = {
  root: 'style',
  text: 'content',
};

export const addTheme = (content, selectedVariant, preserveOverrides) => {
  // NOTE: There were 2 embed templates that adding a block as the button content instead of the
  // expected text primitive. We want to detect that case and fix it, so if the content is a
  // block, we want to take the text primitive from it and discard the block.
  const textContent =
    content.content.type === 'block'
      ? content.content.content
      : content.content;

  return augmentedWrap(content)
    .set(
      PATHS.text,
      addTextTheme(textContent, `${selectedVariant}.text`, preserveOverrides)
    )
    .updateStyle(PATHS.root, { theme: selectedVariant }, preserveOverrides)
    .value();
};

export const overrides = ({ compiledTheme, content }) =>
  [
    calculateOverridePaths({ compiledTheme, content, path: PATHS.root }),
    textOverrides({
      compiledTheme,
      content,
      path: PATHS.text,
      pathName: 'text',
    }),
  ].flat();

export const extractStyles = content => ({
  $style: styleToThemeStyle({ style: get(content, PATHS.root) }),
  text: extractTextStyles(get(content, PATHS.text)),
});
